import { injectable } from 'inversify';

import { getP44Env } from '@project44/ui-utils';

import { IInternalAxiosConfig, IModifiedAxiosRequestConfig } from '../types';

@injectable()
export class InternalAxiosConfigAdapter {
  public toModifiedAxiosRequestConfig<T>(
    internalAxiosConfig: IInternalAxiosConfig<T>,
  ): IModifiedAxiosRequestConfig<T> {
    const { urlSearchParams, ...rest } = internalAxiosConfig;

    const baseUrl = process.env.IS_LOCAL
      ? `https://localhost.api.qa-integration.p-44.com:9181`
      : getP44Env().GATEWAY_API_BASE_URL;

    const resourcePath = process.env.IS_LOCAL
      ? internalAxiosConfig.url
      : `/iam-gateway${internalAxiosConfig.url}`;

    return {
      ...rest,
      baseURL: process.env.BABEL_ENV === 'test' ? 'http://localhost' : baseUrl,
      withCredentials: true,
      method: internalAxiosConfig.method,
      params: urlSearchParams,
      url: resourcePath,
      data: internalAxiosConfig?.axiosBodyPayload as T | undefined,
    };
  }
}
